import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { Primitives } from './primitives';
import { Semantic } from './semantic';
import { Components } from './components';
import { Extended } from './extend';

export const BInclusionTheme = definePreset(Aura, {
  primitive: Primitives,
  semantic: Semantic,
  extend: Extended,
  components: { ...Components },
});
